import { message } from 'antd';
import { queryBookInfoInfo } from '@api/finance/finance';
import PageAdd from './PageAdd';

class PageEdit extends PageAdd {
  componentDidMount() {
    this.getBookInfo();
  }

  getBookInfo = () => {
    queryBookInfoInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };
}

export default PageEdit;



// WEBPACK FOOTER //
// ./src/components/finance/bookInfo/PageEdit.js